import { Head } from 'vite-react-ssg';
import { HeroB2B, Marquee, Roles, Industries, Showcase, AutomatedMessaging, WhyChoose, CommunityBand } from './sections';

/** Homepage (index route) — the warm-but-tech "technology behind the wellness movement" story.
 *  Chrome (nav/footer) is provided by RootLayout; the consumer directory lives at /discover. */
export function App() {
  return (
    <main>
      <Head>
        <title>TechSoFit: the technology behind the wellness movement</title>
        <meta
          name="description"
          content="TechSoFit is the technology behind thriving fitness and wellness businesses across Africa: members, payments, workouts, retention and insights, with a free member app and automated SMS reminders. Built in Zimbabwe."
        />
      </Head>
      <HeroB2B />
      <Marquee />
      <Industries />
      <Roles />
      <Showcase />
      <AutomatedMessaging />
      <WhyChoose />
      <CommunityBand />
    </main>
  );
}
